export default "__VITE_ASSET__B6gwLrdb__"